import * as Sentry from '@sentry/react';
import axiosInstance from './axios';

const BACKEND_API = 'BACKEND_API';


const apiMiddleware = ({ dispatch }) => next => (action) => {
  if (action.type !== BACKEND_API) {
    return next(action);
  }

  const { method, url, params, data, ...rest } = action.payload;

  dispatch({
    type: action.payload.pending,
    payload: action.payload.extra,
    actionId: action?.actionId
  });

  axiosInstance({ method, url, data, params }).then(
    (response) => {
      dispatch({
        type: action.payload.success,
        payload: response.data,
        ...rest
      });
    },

    (error) => {
      if (error?.response?.status === 400) {
        const errorData = {
          response: error?.response?.data,
          requestData: action?.payload,
          airportCode: localStorage.getItem('airportId')
        };
        Sentry.captureMessage(JSON.stringify(errorData));
      }
      dispatch({
        type: action.payload.error,
        payload: error,
        actionId: action?.actionId
      });
    }
  );
  return {};
};

export default apiMiddleware;
